module.exports = __webpack_public_path__ + "media/images/partners/3-0bae8dfa6cf5d7d6ec791ed359179201.png";